import { useLocalStorage } from '@uidotdev/usehooks';
import { PropsWithChildren } from 'react';
import { FavoritesContext } from './FavoritesContext';
import { useClientId } from '@smartfm/container/hooks/useClientId';

const storagePrefixKey = 'buildingSelector';
const isFavoriteFilterActiveKey = `${storagePrefixKey}.isFavoriteFilterActive`;
const favoritesKey = `${storagePrefixKey}.favorites`;

type FavoritesProviderProps = PropsWithChildren;

export function FavoritesProvider(props: FavoritesProviderProps) {
  const { children } = props;

  const [clientId] = useClientId();
  const [isFavoriteFilterActive, setIsFavoriteFilterActive] = useLocalStorage(
    isFavoriteFilterActiveKey,
    false
  );

  const [allFavorites, setAllFavorites] = useLocalStorage<
    Record<string, string[]>
  >(favoritesKey, {});

  function toggleFavorite(value: string) {
    if (!clientId) return;
    setAllFavorites(existingFavorites => {
      const favoritesForClient = existingFavorites[clientId] || [];
      const updatedFavoritesForClient = favoritesForClient.includes(value)
        ? favoritesForClient.filter(item => item !== value)
        : [...favoritesForClient, value];

      if (updatedFavoritesForClient.length === 0) {
        setIsFavoriteFilterActive(false);
        const { [clientId]: _, ...restClients } = existingFavorites;
        return restClients;
      }
      return {
        ...existingFavorites,
        [clientId]: updatedFavoritesForClient,
      };
    });
  }

  function toggleFavoriteFilter(isEnabled: boolean) {
    setIsFavoriteFilterActive(isEnabled);
  }

  const favorites = clientId ? allFavorites[clientId] || [] : [];

  return (
    <FavoritesContext.Provider
      value={{
        favorites,
        toggleFavorite,
        isFavoriteFilterActive,
        toggleFavoriteFilter,
      }}
    >
      {children}
    </FavoritesContext.Provider>
  );
}
